/**
 * @description Create a date from the given Unix timestamp (in seconds).
 *
 * @param {number} unixTime The given unix timestamp in seconds.
 *
 * @returns {Date} The date from the given unix timestamp.
 */
export var getDateFromUnixTime = function (unixTime) { return new Date(unixTime * 1000); };
//# sourceMappingURL=getDateFromUnixTime.js.map